import { Text } from "@/components/ui/text";
import { Button, ButtonText } from "@/components/ui/button";
import { VStack } from "@/components/ui/vstack";
import { useDispatch, useSelector } from "react-redux";
import i18n from "i18n-js";
import React from "react";
import ModalBase from "@/components/basic/ModalBase";
import { updateSettings } from "@/stores/mainSlice";

export default function ModalFilter({ showModal, setShowModal }) {
  const dispatch = useDispatch()
  const filter = useSelector((state) => state.settings.taskFilter)

  const setFilter = filter => {
    dispatch(updateSettings({ settings: { taskFilter: filter } }))
    setShowModal(false)
  }

  return (
    <ModalBase showModal={showModal}>
      <Text bold className="text-xl text-secondary-800 mb-5">{i18n.t('searchScreen.filterText')}</Text>
      <VStack space='sm' direction='column' className="w-[100%]">
        <Button variant='outline' onPress={() => { setFilter(0) }} className={` ${filter == 0 ? "bg-primary-900" : "bg-secondary-50"} border-primary-900 data-[active=true]:bg-primary-700`}>
          <ButtonText className={` ${filter == 0 ? "text-primary-50" : "text-primary-900"} text-lg data-[active=true]:text-secondary-50`}> {i18n.t('searchScreen.buttonAll')}</ButtonText>
        </Button>
        <Button variant='outline' onPress={() => { setFilter(1) }} className={` ${filter == 1 ? "bg-primary-900" : "bg-secondary-50"} border-primary-900 data-[active=true]:bg-primary-700 `}>
          <ButtonText className={` ${filter == 1 ? "text-primary-50" : "text-primary-900"} text-lg data-[active=true]:text-secondary-50 `}>{i18n.t('searchScreen.buttonMine')}</ButtonText>
        </Button>
        <Button variant='outline' onPress={() => { setFilter(2) }} className={` ${filter == 2 ? "bg-primary-900" : "bg-secondary-50"} border-primary-900 data-[active=true]:bg-primary-700 `}>
          <ButtonText className={` ${filter == 2 ? "text-primary-50" : "text-primary-900"} text-lg data-[active=true]:text-secondary-50`}> {i18n.t('searchScreen.buttonOthers')}</ButtonText>
        </Button>
        <Button variant='outline' onPress={() => { setFilter(3) }} className={` ${filter == 3 ? "bg-primary-900" : "bg-secondary-50"} border-primary-900 data-[active=true]:bg-primary-700`}>
          <ButtonText className={` ${filter == 3 ? "text-primary-50" : "text-primary-900"} text-lg data-[active=true]:text-secondary-50`}> {i18n.t('searchScreen.buttonScanGo')}</ButtonText>
        </Button>
        <Button variant='outline' onPress={() => { setFilter(4) }} className={` ${filter == 4 ? "bg-primary-900" : "bg-secondary-50"} border-primary-900 data-[active=true]:bg-primary-700`}>
          <ButtonText className={` ${filter == 4 ? "text-primary-50" : "text-primary-900"} text-lg data-[active=true]:text-secondary-50`}> {i18n.t('searchScreen.buttonStudio')}</ButtonText>
        </Button>
        <Button variant='outline' onPress={() => { setFilter(5) }} className={` ${filter == 5 ? "bg-primary-900" : "bg-secondary-50"} border-primary-900 data-[active=true]:bg-primary-700`}>
          <ButtonText className={` ${filter == 5 ? "text-primary-50" : "text-primary-900"} text-lg data-[active=true]:text-secondary-50`}> {i18n.t('searchScreen.buttonApp')}</ButtonText>
        </Button>
      </VStack>
    </ModalBase>
  );
}
